import { Component, HostListener, OnInit } from '@angular/core';
import { RelatorioDreService } from '../../../services/relatorios/relatorio-dre.service';
import { RelatorioDreParams } from '../../../models/relatorios/relatorio-dre.model';
import { PeriodoFiltro } from '../../../models/dashboard/periodo-filtro.model';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { FileUtils } from '../../../shared/utils/file-utils';
import { calcularPeriodoPadraoRelatorio } from '../../../shared/utils/periodo-relatorio-padrao.util';
import { PRESETS_PERIODO_RELATORIO } from '../../../shared/utils/periodo.utils';

@Component({
  selector: 'app-relatorio-dre',
  templateUrl: './relatorio-dre.component.html',
  styleUrls: ['./relatorio-dre.component.scss']
})
export class RelatorioDreComponent implements OnInit {

  // Texto exibido no botao do filtro de periodo (app-periodo-filtro, modo avancado).
  periodoTexto = '';

  // Presets do filtro de periodo: lista padrao + "Mostrar todos" (so relatorios).
  readonly opcoesPeriodo = PRESETS_PERIODO_RELATORIO;

  params: RelatorioDreParams = {
    dataInicio: '',
    dataFim: ''
  };

  emitindoRelatorio: boolean = false;

  constructor(
    private translate: TranslateService,
    private messageService: MessageService,
    private relatorioDreService: RelatorioDreService
  ) { }

  ngOnInit(): void {
    this.inicializarPeriodoPadrao();
  }

  // Inicializa o periodo padrao ("Mostrar todos") para que os params tenham
  // datas antes de o usuario abrir o dialog. O app-periodo-filtro nao emite no
  // init, entao replicamos o que os demais relatorios fazem.
  private inicializarPeriodoPadrao(): void {
    this.aplicarPeriodo(calcularPeriodoPadraoRelatorio(this.translate));
  }

  // Handler do (periodoChanged) do app-periodo-filtro.
  onPeriodoChanged(periodo: PeriodoFiltro): void {
    this.aplicarPeriodo(periodo);
  }

  private aplicarPeriodo(periodo: PeriodoFiltro): void {
    this.params.dataInicio = periodo.dataInicio;
    this.params.dataFim = periodo.dataFim;
    this.periodoTexto = periodo.texto;
  }

  emitirRelatorio(): void {
    this.emitindoRelatorio = true;

    this.relatorioDreService.emitirRelatorio(this.params)
      .subscribe(
        {
          next: (pdfBase64: string) => {
            FileUtils.abrirPdf(pdfBase64, 'relatorio_dre.pdf');
            this.emitindoRelatorio = false;
          },
          error: (err) => {
            console.error('Erro ao gerar o relatório DRE:', err);
            this.emitindoRelatorio = false;

            if (err?.status === 404) {
              this.messageService.add({
                severity: 'warn',
                summary: this.translate.instant('common.aviso'),
                detail: this.translate.instant('relatorios.mensagens.nenhum_dado_encontrado'),
              });
            } else {
              this.messageService.add({
                severity: 'error',
                summary: this.translate.instant('common.erro'),
                detail: this.translate.instant('relatorios.mensagens.erro_gerar_relatorio'),
              });
            }
          },
        });
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.ctrlKey && event.key === 'Enter' && !this.emitindoRelatorio) {
      event.preventDefault();
      this.emitirRelatorio();
    }
  }
}
